import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const requiredRoles = (route.data?.['roles'] as string[]) || [];
  if (requiredRoles.length === 0) return true;
  const roles = auth.roles();
  const has = roles.some(r => requiredRoles.includes(r));
  if (!has) {
    router.navigate(['/']);
    return false;
  }
  return true;
};


